import {BaseUtils} from "./base.utils";
import {WatchService} from "../watch.service";
import {StageService} from "../conditionService";
import {ICondition} from "../../interfaces/condition.definition";


export class ConditionsUtils extends BaseUtils {
  constructor(watchService: WatchService,
              private stageService: StageService) {
    super(watchService);
  }


  initializeParams(condition: ICondition) {
    this.stageService.initializeConditionParams(condition);
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/services/factory-service-impl/conditions.utils.ts